<template>
  <base-page v-bind="payload" :error="error" />
</template>

<script>
  import BasePage from './_base';

  export default {
    components: { BasePage },
    data() {
      return {
        error: {
          code: '404'
        }
      }
    },
    props: {
      payload: {
        type: Object,
        default: () => ({})
      }
    }
    
  };
</script>
